import * as types from "./types"
import http_pay from "@/utils/http_pay"
import http from "@/utils/http"
// 轻提示
import { Toast } from 'vant';

let state = {
  list: [],
  allLoad: false, // 加载完成
  isLoad: true, // 正在加载
  noData: false, // 暂无数据
  pageSize: 5,
  quanLen: "", // 我的-> 优惠券数量
  // 我的月卡
  monthCardList: [],
  // 我的车辆
  carList: [],
  // 我的优惠券
  couponList: [],
  // 车场管理
  wechatNoticeList: [],
  // 我的账单
  billList: [],
  couponInfoList: [],
  dayReportList: [],
  monthReportList: [],
  page: 0,
  type: ""
}
let actions = {
  /** 我的月卡 */
  [types.MERBERMONTHCARDQUERY] (context, params) {
    http.post('p-ypt-merberMonthCard-query', params).then(data => {
      context.commit(types.MERBERMONTHCARDQUERY, data)
    })
  },
  /** 我的车辆 */
  [types.MERBERCARQUERY] (context, params) {
    http_pay.post('p-ypt-merberCar-query', params).then(data => {
      context.commit(types.MERBERCARQUERY, data)
    })
  },
  [types.MERBERCARUPDATE] (context, params) {
    http.post('p-ypt-merberCar-update', params).then(data => {
      context.commit(types.MERBERCARUPDATE, data)
    })
  },
  [types.MERBERCARDELETE] (context, params) {
    http_pay.post('p-ypt-merber-car-delete', params).then(data => {
      context.commit(types.MERBERCARDELETE, data)
    })
  },
  [types.ISNOSENSEUPDATE] (context, params) {
    http.post('p-ypt-merber-car-isNoSense-update', params).then(data => {
      context.commit(types.ISNOSENSEUPDATE, data)
    })
  },
  /** 我的优惠券 */
  [types.MERBERCOUPONSQUERY] (context, params) {
    http.post('p-ypt-merberCoupons-query', params).then(data => {
      context.commit(types.MERBERCOUPONSQUERY, data)
    })
  },
  [types.WECHATNOTICE] (context, params) {
    http.post('p-ypt-wechat-notice-query', params).then(data => {
      context.commit(types.WECHATNOTICE, data)
    })
  },
  [types.PARKUNBUNDING] (context, params) {
    http.post('p-ypt-wechat-notice-delete', params).then(data => {
      context.commit(types.PARKUNBUNDING, data)
    })
  },
  [types.MERBERCOUPONSQUERYLEN] (context, params) {
    http.post('p-ypt-merberCoupons-query', params).then(data => {
      context.commit(types.MERBERCOUPONSQUERYLEN, data)
    })
  },
  /** 我的账单 */
  [types.MYBILLQUERY] (context, params) {
    state.page += 1
    state.type = params.type
    http.post('p-ypt-myBill-query', { page: state.page, pageSize: 4, type: state.type }).then(data => {
      context.commit(types.MYBILLQUERY, data)
    })
  },
  [types.COUPON] (context, params) {
    state.page += 1
    state.type = params.type
    http.post('p-ypt-business-coupons-query', { page: state.page, pageSize: 4, type: state.type }).then(data => {
      context.commit(types.COUPON, data)
    })
  },
  [types.DAYREPORT] (context, params) {
    state.page += 1
    state.type = params.type
    http.post('p-ypt-temporaryStop-query', { page: state.page, pageSize: 4, type: state.type,cycle: params.cycle,dataTime: params.dataTime }).then(data => {
      context.commit(types.DAYREPORT, data)
    })
  },
  [types.MONTHREPORT] (context, params) {
    state.page += 1
    state.type = params.type
    http.post('p-ypt-temporaryStop-query', { page: state.page, pageSize: 4, type: state.type,cycle: params.cycle,dataTime: params.dataTime }).then(data => {
      context.commit(types.MONTHREPORT, data)
    })
  },
}
let mutations = {
  /** 我的月卡 */
  [types.MERBERMONTHCARDQUERY] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      let index = data.data
      if (index.dataList.length >= 1) {
        state.noData = false
        state.monthCardList = state.monthCardList.concat(index.dataList)
        state.isLoad = false
        if (index.total <= state.pageSize) { // 只有一页
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  /** 我的车辆 */
  [types.MERBERCARQUERY] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) {
        if (index.dataList.length >= 1) {
          state.carList = state.carList.concat(index.dataList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  [types.ISNOSENSEUPDATE] (state, data) {
    if (data.code==='ok') {
    } else {
      Toast(data.message)
    }
  },
  [types.MERBERCARUPDATE] (state, data) {
    if (data.code==='ok') {
    } else {
      Toast(data.message)
    }
  },
  [types.MERBERCARDELETE] (state, data) { // 解绑车辆
    if (data.code==='ok') {
      Toast('车辆解绑成功')
      this.commit("CHANGELOAFDSTATUS", { isLoad: true });
      this.commit("RESETPARAMS");
      this.dispatch(types.MERBERCARQUERY, {
        page: 1,
        pageSize: state.pageSize
      });
    } else {
      Toast(data.message)
    }
  },
  [types.PARKUNBUNDING] (state, data) { // 解绑订阅消息
    if (data.code==='ok') {
      Toast('车场状态取消订阅成功')
      this.commit("CHANGELOAFDSTATUS", { isLoad: true });
      this.commit("RESETPARAMS");
      this.dispatch(types.WECHATNOTICE, {
        page: 1,
        pageSize: state.pageSize
      });
    } else {
      Toast(data.message)
    }
  },
  /** 我的优惠券 */
  [types.MERBERCOUPONSQUERY] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) { // 进行分页
        if (index.dataList.length >= 1) {
          state.couponList = state.couponList.concat(index.dataList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  /** 车场监控 */
  [types.WECHATNOTICE] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) { // 进行分页
        if (index.dataList.length >= 1) {
          state.wechatNoticeList = state.wechatNoticeList.concat(index.dataList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  [types.MERBERCOUPONSQUERYLEN] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.quanLen = data.data.total
    } else {
      Toast(data.message)
    }
  },
  /** 我的账单 */
  [types.MYBILLQUERY] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) { // 进行分页
        if (index.dataList.length >= 1) {
          state.billList = state.billList.concat(index.dataList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  [types.COUPON] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) { // 进行分页
        if (index.dataList.length >= 1) {
          state.couponInfoList = state.couponInfoList.concat(index.dataList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  [types.DAYREPORT] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) { // 进行分页
        if (index.reportList.length >= 1) {
          state.dayReportList = state.dayReportList.concat(index.reportList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  [types.MONTHREPORT] (state, data) {
    state.isLoad = true
    if (data.code==='ok') {
      state.isLoad = false
      let index = data.data
      if (index.totalPage != 0) { // 进行分页
        if (index.reportList.length >= 1) {
          state.monthReportList = state.monthReportList.concat(index.reportList)
        } else {
          state.allLoad = true
        }
      } else { // 暂无数据
        state.noData = true
      }
    } else {
      state.isLoad = false
      Toast(data.message)
    }
  },
  // 改变分页加载状态 => 正在加载
  CHANGELOAFDSTATUS (state, data) {
    state.isLoad = data.isLoad
  },
  // 改变分页加载状态 => 正在加载
  UPDATECOUPINLIST (state, data) {
    state.couponList = data.couponList
    state.wechatNoticeList = data.wechatNoticeList
  },
  // 重置参数设备列表 分页参数
  RESETPARAMS (state, data) {
    // console.log("reset-query-data")
    state.page = 0
    state.noData = false
    state.allLoad = false
    state.isLoad = true
    state.type = ""
    // 清空累加的数据
    state.billList = []
    state.monthCardList = []
    state.carList = []
    state.couponList = []
    state.wechatNoticeList = []
    state.couponInfoList = []
    state.dayReportList = []
    state.monthReportList = []
  },
  // 设置全部加载完成
  ALLLOAD (state) {
    state.allLoad = true
    state.isLoad = false
  },
}


export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/mine/index.js